<div class="date-picker">
  <div class="header">
    <button type="button" class="label" (click)="openYears()" [disabled]="view() === 'years'">
      {{ headerLabel() }}
    </button>
    <div class="nav-group">
      <button type="button" class="nav" (click)="step(-1)">
        <i class="material-icons-outlined">chevron_left</i>
      </button>
      <button type="button" class="nav" (click)="step(1)">
        <i class="material-icons-outlined">chevron_right</i>
      </button>
    </div>
  </div>

  @switch (view()) {
    @case ('days') {
      <div class="weekdays">
        @for (weekday of weekdays; track $index) {
          <span class="weekday" [class.weekend]="$index > 4">{{ weekday }}</span>
        }
      </div>

      @for (week of weeks(); track $index) {
        <div class="week">
          @for (day of week; track day.date.valueOf()) {
            <button
              type="button"
              class="day"
              [class.outside]="day.outside"
              [class.weekend]="day.weekend"
              [class.today]="day.today"
              [class.selected]="day.selected"
              [disabled]="day.disabled"
              (click)="select(day)">
              {{ day.label }}
            </button>
          }
        </div>
      }
    }

    @case ('months') {
      <div class="grid months">
        @for (month of months(); track month.date.valueOf()) {
          <button
            type="button"
            class="cell"
            [class.today]="month.today"
            [class.selected]="month.selected"
            [disabled]="month.disabled"
            (click)="selectMonth(month)">
            {{ month.label }}
          </button>
        }
      </div>
    }

    @case ('years') {
      <div class="grid years">
        @for (year of years(); track year.date.valueOf()) {
          <button
            type="button"
            class="cell"
            [class.today]="year.today"
            [class.selected]="year.selected"
            [disabled]="year.disabled"
            (click)="selectYear(year)">
            {{ year.label }}
          </button>
        }
      </div>
    }
  }
</div>
